export type ScrollToIdOptions = {
  behavior?: ScrollBehavior;
  extraOffsetPx?: number;
  maxFrames?: number;
};

const DEFAULT_MAX_FRAMES = 120;

const getHeaderHeightPx = (): number => {
  const header = document.querySelector("header");
  if (!header) return 0;
  return Math.round(header.getBoundingClientRect().height);
};

export const scrollToIdWithHeaderOffset = (
  id: string,
  { behavior = "smooth", extraOffsetPx = 0, maxFrames = DEFAULT_MAX_FRAMES }: ScrollToIdOptions = {},
): void => {
  const attemptScroll = (attempt: number) => {
    const el = document.getElementById(id);
    if (!el) {
      if (attempt < maxFrames) requestAnimationFrame(() => attemptScroll(attempt + 1));
      return;
    }

    const headerOffset = getHeaderHeightPx() + extraOffsetPx;
    const top = el.getBoundingClientRect().top + window.scrollY - headerOffset;
    window.scrollTo({ top, behavior });
  };

  requestAnimationFrame(() => attemptScroll(0));
};
